<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="false" @add="novoRegistro"
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nrLoteControle" label="Lote de Controle" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field v-model.trim="registro.nrPavilhao" label="Pavilhão" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md4 lg4>
                    <SelectDate :rules="[campoObrigatorio, validarData, validarDataFutura]" label="Data Criação" v-model="dataCriacao"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md7 lg7>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.sgSexo" :items="tiposGenero" clearable
                        color="primary" item-text="dsSexo" item-value="sgSexo" label="Selecione o gênero dos animais" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete v-model="registro.cdResponsavelTecnico" :items="extensionistas" clearable
                        color="primary" item-text="displayName" item-value="idResponsavelTecnico" label="Selecione o extensionista por nome ou cpf" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11 v-if="!isEditing">
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdEstabelecimento" :items="estabelecimentos" clearable
                        color="primary" item-text="displayName" item-value="idEstabelecimento" @change="changeEstabelecimentoValue"
                        label="Selecione o estabelecimento por código oficial ou nome" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11 v-if="!isEditing">
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdUnidadeExploracao" :items="unidadesExploracao" clearable
                        color="primary" item-text="displayName" item-value="idUnidadeExploracao"
                        label="Selecione a unidade exploração por número ou tipo" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete v-model="registro.cdProdutor" :items="produtores" clearable
                        color="primary" item-text="displayName" item-value="idProdutor"
                        label="Selecione o produtor por CPF ou nome" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            
            <v-layout row wrap justify-end style="margin-top: -20px;" v-if="isEditing">
                <v-flex class="item" xs10 md10 lg5>
                    <v-btn id="updateLote" rounded color="background-color:#e8e8e8;" @click="atualizaJSONLote">
                        <v-icon small>fas fa-sync</v-icon>
                        <span class="marginSpan" v-if='!this.$vuetify.breakpoint.xs'> Atualizar dados Estabelecimento </span>
                        <span class="marginSpan" v-else> Atualizar dados </span>
                    </v-btn>
                </v-flex>
            </v-layout>
            
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="isEditing" @delete="deleteRegistro"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, validarData, validarDataFutura } from '@/filters/rules'
import { TituloShouldNavigate, MensagemShouldNavigate, MensagemSuccessSave } from '@/resourceMessageFile.js'
import { dateLocalToIso, dateIsoToLocal, uepTypeExpand, formatCPF, formatCNPJ } from '@/filters/utils'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import SelectDate from '@/components/general/SelectDate.vue'

const toProdutoreView = entry => {
    var documento = ''
    if (entry.nrDocumento.length > 11)
    {
        documento = formatCNPJ(entry.nrDocumento)
    }
    else
    {
        documento = formatCPF(entry.nrDocumento)
    }
    let displayName = documento + ' | ' + entry.nmProdutor
    return {...entry, displayName}
}

const toUepsView = entry => {
    let displayName = entry.nrUnidadeExploracao + ' - ' + uepTypeExpand(entry.csTipoUnidadeExploracao)
    return {...entry, displayName}
}

export default {
    name: 'LoteProducao',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        SelectDate,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            selected: [],
            dataCriacao: '',
            unidadesExploracao: [],
            produtores: [],
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Lote de Produção: ' + this.registro.idLoteProducao

                return 'Inserindo novo Lote de Produção'
            }
        },
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        tabelasConsumoRacao () {
            return this.$store.state.tabelasConsumoRacao
        },
        extensionistas () {
            return this.$store.state.extensionistas
        },
        tiposGenero () {
            return this.$store.state.tiposGenero
        },
        urlAPIEstabelecimento() {
            return this.$store.state.urlAPIEstabelecimento
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        validarData, 
        validarDataFutura, 
        dateLocalToIso,
        dateIsoToLocal,
        uepTypeExpand,
        formatCPF,
        formatCNPJ,
        atualizaJSONLote() {
            this.registro.atualizaEstabelecimento = true
            this.registro.atualizaUnidadeExploracao = true
            this.registro.atualizaProdutor = true
            this.updateRegistro()
        },
        deleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
                .then(confirm => {
                    if (confirm){
                        this.$axios.delete('lote-producao/' + this.registro.idLoteProducao)
                        .then( response => {
                            this.goSearch()
                        })
                        .catch((error) => {
                            this.changeViewState('isError', error)
                        })
                    }
                })
        },
        loadProdutores(idEstabelecimento) {
            var context = this
            this.$axios.get(this.urlAPIEstabelecimento + 'produtor/?cdEstabelecimento=' + idEstabelecimento)
            .then((response) => {
                context.produtores = response.data ? response.data.map(toProdutoreView) : []
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        loadUEPs(idEstabelecimento) {
            var context = this
            this.$axios.get(this.urlAPIEstabelecimento + 'unidadeExploracao/?cdEstabelecimento=' + idEstabelecimento)
            .then((response) => {
                var unidadesExploracao = response.data ? response.data.filter(entry => entry.stAtivo).map(toUepsView) : []
                context.unidadesExploracao = unidadesExploracao
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        changeEstabelecimentoValue(value) {
            if (value != undefined)
            {
                this.unidadesExploracao = this.loadUEPs(value)
                this.produtores = this.loadProdutores(value)
            }
            else
            {
                this.unidadesExploracao = []
                this.produtores = []
            }
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadEstabelecimentos')
            this.$store.dispatch('actLoadTabelasConsumoRacao')
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.listPrincipiosAtivo = []
            this.$axios.get('lote-producao/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.dataCriacao = this.dateIsoToLocal(rec.dtCriacaoLote)
                this.produtores = this.loadProdutores(rec.cdEstabelecimento)
                this.registro = Object.assign({}, rec)
                this.registroBanco = Object.assign({}, rec)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
                this.$router.push({ path: '/loteProducaoForm'})
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.nrPavilhao = this.registro.nrPavilhao == '' ? null : this.registro.nrPavilhao
            this.registro.dtCriacaoLote = this.dateLocalToIso(this.dataCriacao)
            this.$axios.post('lote-producao/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'loteProducao', params: { id: response.data[0].data.idLoteProducao }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadLotesProducao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.nrPavilhao = this.registro.nrPavilhao == '' ? null : this.registro.nrPavilhao
            this.registro.dtCriacaoLote = this.dateLocalToIso(this.dataCriacao)

            var registroToUpdate = this.registro
            delete registroToUpdate.baixa;
            delete registroToUpdate.admFarmaco;
            delete registroToUpdate.divergenciaEntradaAnimais;
            delete registroToUpdate.entradaAnimais;
            delete registroToUpdate.entradaRacao;
            delete registroToUpdate.informeSaldoRacao;
            delete registroToUpdate.jsonConsumoReal;
            delete registroToUpdate.jsonEstabelecimento;
            delete registroToUpdate.jsonPeso;
            delete registroToUpdate.jsonProdutor;
            delete registroToUpdate.jsonUnidadeExploracao;
            delete registroToUpdate.pedidoRacao;

            this.$axios.put('lote-producao/' + this.registro.idLoteProducao, registroToUpdate)
                .then(() => {
                    this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                    this.initViewFromRoute(this.$route)
                    this.$store.dispatch('actLoadLotesProducao')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                })
        },
        novoRegistro() {
            this.$router.push({ path: '/loteProducaoForm' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idLoteProducao: 0,
                dtCriacaoLote: '',
                nrLoteControle: '',
                nrPavilhao: null,
                cdEstabelecimento: null,
                cdUnidadeExploracao: null,
                cdTabelaConsumoRacao: null,
                cdResponsavelTecnico: null,
                sgSexo: '',
            }
            this.registroBanco = {
                idLoteProducao: 0,
                dtCriacaoLote: '',
                nrLoteControle: '',
                nrPavilhao: null,
                cdEstabelecimento: null,
                cdUnidadeExploracao: null,
                cdTabelaConsumoRacao: null,
                cdResponsavelTecnico: null,
                sgSexo: '',
            }
        },
        voltar() {
            this.$router.go(-1)
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 370 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        goSearch() {
            this.$router.push({ path: '/loteProducaoSearch' })
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
